import AuthPage from '@/pages/AuthPage/AuthPage.vue'

export default AuthPage
